export const SAVE_CUSTOMER_MESSAGES = {
    BULK_UPDATED: "Records updated successfully!",
    BULK_UPDATED_ERROR: "Error while updating records. Please try again",
    CUSTOMER_UPDATED: "Customer updated successfully!",
    CUSTOMER_UPDATED_ERROR: "Customer updated failed!",
};

export const DATA_REVIEW_CONSTANTS = {
    NO_DATA: "No data to display",
    SEARCH_PLACEHOLDER: "Search Campaign",
    CUSTOMER_SEARCH_PLACEHOLDER: "Search by Name and Customer ID",
}

export const DATA_REVIEW_COLUMN_KEYS = {
    ACTIONS: "actions",
    CAMPAIGN_NAME: "campaignName",
    UPLOAD_DATE: "uploadDate",
}

export const DATA_REVIEW_TABLE_COLUMNS = [
    { id: "actions", isSortable: false, label: "Actions" },
    { id: "campaignName", isSortable: true, label: "Campaign Name" },
    { id: "uploadDate", isSortable: true, label: "Upload Date" },
];

export const UPLOAD_CUSTOMER_TABLE_COLUMNS = [
    { id: "actions", isSortable: false, label: "Actions" },
    { id: "id", isSortable: false, label: "ID" },
    { id: "published", isSortable: false, label: "Published" },
    { id: "convapproved", isSortable: false, label: "Converse" },
    { id: "customerid", isSortable: true, label: "Customer ID" },
    { id: "name", isSortable: true, label: "Customer Name" },
    { id: "emailaddress", isSortable: true, label: "Email" },
    { id: "customeruniqueid", isSortable: false, type:"phone", label: "Phone Number" },
    { id: "campaignName", isSortable: true, label: "Campaign Name" },
]

export const UPLOAD_CUSTOMER_TABLE_COLUMNS_KEYS = {
    ID: "id",
    ACTIONS: "actions",
    NAME: "name",
    PUBLISHED: "published",
    CONVAPPROVED: "convapproved",
    REPODATE: "repodate"
} 